import React from 'react';
import styles from './TutorialLossPopup.module.css';
import { useLanguage } from '../Providers/LanguageContext';

interface TutorialLossPopupProps {
  isVisible: boolean;
  tutorialTitle: string;
  lossMessage?: string; // Optional custom loss message
  onClose: () => void;
  onRestart: () => void;
  onNext?: () => void; // Optional callback to navigate to next tutorial
}

function TutorialLossPopup({
  isVisible,
  tutorialTitle,
  lossMessage,
  onClose,
  onRestart,
  onNext
}: TutorialLossPopupProps) {
  const { t } = useLanguage();

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <div className={styles.header}>
          <h2 className={styles.title}>{t('tutorials.failed')}</h2>
          <div className={styles.failIcon}>
            <div className={styles.xMark}>✕</div>
          </div>
        </div>

        <div className={styles.content}>
          <h3 className={styles.tutorialTitle}>{tutorialTitle}</h3>
          <p className={styles.lossMessage}>
            {lossMessage || t('tutorials.failedDefaultMessage')}
          </p>
        </div>

        <div className={styles.actions}>
          <button onClick={onRestart} className={styles.restartButton}>
            {t('tutorials.tryAgain')}
          </button>
          <button onClick={onClose} className={styles.closeButton}>
            {t('tutorials.back')}
          </button>
          {onNext && (
            <button onClick={onNext} className={styles.nextButton}>
              {t('tutorials.next')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default TutorialLossPopup;